// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__gothamBook_2724cf', '__gothamBook_Fallback_2724cf', system-ui, sans-serif","fontStyle":"normal"},"className":"__className_2724cf"};